import React from 'react';
import { Grid, Link } from '@forgeglobal/design-framework';
import ForgeTrustIcon from '@tcs/common/components/atoms/Logo';
import HeaderProfile from '@tcs/client-portal-common/components/molecules/HeaderProfile';
import useStyles from './BaseLayout.styles';
import cs from 'classnames';

interface HeaderProps {
  shouldShowUser?: boolean;
  fixed?: boolean;
}

const Header = ({ shouldShowUser, fixed = false }: HeaderProps) => {
  const classes = useStyles();

  return (
    <div
      className={cs(classes.headerWrapper, {
        [classes.headerWrapperFixed]: fixed,
      })}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className={classes.headerContainer}>
        <div className={classes.logoContainer}>
          <Link
            href="/client-portal/accounts"
            className={classes.logoLink}
            aria-label="Forge Trust Home">
            <ForgeTrustIcon data-test-id="forge-icon" />
          </Link>
        </div>
        {shouldShowUser && <HeaderProfile />}
      </Grid>
    </div>
  );
};

export default Header;
